// extracted by mini-css-extract-plugin
module.exports = {"consentBox":"Analytics_consentBox__ZwKIz","consentButtons":"Analytics_consentButtons__v6KlQ"};